<template>
	<div>
		<div class="col-md-4 pt-3 centre_sm_none">
			<div class="right_list_content">
				<p id="right_content_title_information" class="pl-3">
					<i class="fa fa-building-o fa-lg mr-2"></i>{{getzines.name}}
				</p>
				<div class="row nano p-0 m-0 one_title_nano">
					<div class="nano-content">
						<div style="padding: 0px 20px;">
							<div class="col-md-12" style="padding: 30px 0px;">
								<img v-if="getzines.logo" :src="getzines.logo" class="col-md-5 offset-md-4 p-0 img-thumbnail p-1" style="width: auto;display: block;margin: 0 auto;">
							</div>
							<div style="padding-bottom: 30px;">
								<h4 class="periodical_synopsis">Introduction</h4>
                                <div class="periodical_synopsi" v-if="getzines.example != null" @click="getIssueDetail(getzines.example)">
                                    <img src="../../../assets/images/silkRoadBase/book.png" alt="" />Sample issue</div>
								<p class="periodical_content">
									{{getzines.memo}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none">
			<div class="right_content_previous sm_no_hide">
				<p class="right_previous_intelligence">
					Review
				</p>
				<div class="row nano p-0 m-0 one_title_nano">
					<div class="nano-content" id="home_right_list" :class="{'cur':!IsPC()}">
						<ul class="list-unstyled">
							<li v-for="getissue in getissues" class="media pb-3 pt-3 pl-4 pr-3 border-bottom mb-3" style="position: relative;">

								<img v-if="getissue.image != ''" class="mr-3 col-md-2 col-5 img-thumbnail" :src="getissue.image" style="padding: 4px;" />
								<div class="media-body">
									<h5><a href="javascript:" @click="getIssueDetail(getissue.eid)">{{getissue.title}}</a></h5>
									<div class="media-foot mt-1 font-weight-light">
										<p class="f13 inteList mb-0">
											{{getissue.description}}
										</p>
									</div>
								</div>
							</li>
                            <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default({
		name: 'intelligence',
		data: function() {
			return {
				getissues: [],
				getzines: [],
				id: this.$route.params.id,
				page: 1,
				page_size: 10,
				total_page: 1,
                loadShow :  false
			}
		},
		created: function() {
			var self = this;
			if ($.inArray(self.id, ['22', '23', '24']) >= 0) {
                this.$router.push({path:'/countryreport/'+self.id+'/2018'})
            }
			this.$axios.post('/api/pc/getzine', {
				id: self.id
			}).then(data => {
				var getzines = data.data.data;
				self.getzines = getzines;
                setTimeout(function () {
                    $(".right_list_content .one_title_nano").css({"height":$(".right_list_content .nano-content").height()})
                    },2000)


			})
			this.$axios.post('/api/pc/getissue', {
				id: self.id,
				current_page: self.page,
				page_size: self.page_size
			}).then(data => {
				var getissues = data.data.data.data;
				self.total_page = Math.ceil(data.data.data.total / self.page_size);
				self.getissues = getissues;
			})
		},

		mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			 this.load()
            this.getZine()
		},
		methods: {
			handleScroll() {
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				if(((all - 20) < (top + client)) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
						return;
					}
					let that = this;
					that.loadShow = true;
					this.$axios.post('/api/pc/getissue', {
						id: that.id,
						current_page: that.page,
						page_size: that.page_size
					}).then(data => {
						var getissues = data.data.data.data;
						that.getissues = that.getissues.concat(getissues);
						that.loadShow = false;
					})
				}
			},
            getIssueDetail : function(eid) {
//              this.$axios.post('/api/pc/getissuedetail',{id:eid}).then(data => {
//                  if (data.data.state && data.data.data.pdf) {
//                      window.open(data.data.data.pdf);
//                  }
//              })

				this.$router.push({path:'/report/'+this.id+'/issue/'+eid})
            },
            getZine :function() {
                if ($.inArray(this.id, ['22', '23', '24']) >= 0) {
                    this.$router.push({path:'/countryreport/'+this.id+'/2018'})
                }
                this.$axios.post('/api/pc/getzine', {id:this.id}).then(data => {
                    var getzines=data.data.data;
                    this.getzines=getzines;
                })
                this.$axios.post('/api/pc/getissue',{id:this.id,current_page:this.page,page_size:this.page_size}).then(data => {
                    var getissues=data.data.data.data;
                    this.total_page = Math.ceil(data.data.data.total / this.page_size);
                    this.getissues=getissues;
                })
            },
        },
        watch: {
            $route(){
                this.id = this.$route.params.id
            },
            id() {
                this.getZine()
            },
        }
	})
</script>
<style scoped>
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .periodical_synopsis,.periodical_synopsi{
        display:inline-block
    }
    .periodical_synopsi{
        float:right;
        text-align:center;
        padding:6px 14px;
        height:32px;
        background:rgba(32,142,255,1);
        border-radius:18px;

        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:23px;
    }
    .periodical_synopsi:hover{
        cursor:pointer;
    }
    .periodical_synopsi img{
        width:13px;
        height:16px;
        margin-right:5px;
    }
</style>
